import { SxProps, Theme } from "@mui/material";

export {
  buttonsContainerStyles,
  errorTypographyStyles,
  fieldContainerStyles,
  getInputLabelStyles,
  getSelectStyles,
  getTextFieldStyles,
  layoutStyles,
  mainButtonStyles,
  menuItemStyles,
  modalBoxStyles,
  popperStyles,
  secondaryButtonStyles,
} from "../create-user-form/styles";

const SELECTED_PRIMARY = "rgb(25, 118, 210)";

export const dayStyles: SxProps<Theme> = (theme) => ({
  borderRadius: "10px",
  "&:hover": {
    backgroundColor: theme.palette.adminPanel.calendarBgHover,
  },
  "&.Mui-selected": {
    backgroundColor: `${SELECTED_PRIMARY} !important`,
    color: "#fff !important",
  },
  "&.MuiPickersDay-today": {
    color: SELECTED_PRIMARY,
    border: "none",
    backgroundColor: theme.palette.adminPanel.calendarTodayBg,
  },
});

export const yearButtonStyles = (theme: any) => ({
  "&.Mui-selected": {
    backgroundColor: `${SELECTED_PRIMARY} !important`,
    color: "#fff !important",
  },
  "&:hover": {
    backgroundColor: theme.palette.adminPanel.calendarBgHover,
  },
});

export const headerTypographyStyles: SxProps<Theme> = (theme) => ({
  color: theme.palette.modalColors.headerColor,
});

export const successTypographyStyles: SxProps = {
  fontFamily: "Red Hat Display",
  color: "#15803d",
  textAlign: "left",
  margin: 0,
};

export const dropzoneStyles =
  (isDragActive: boolean): SxProps<Theme> =>
  (theme) => ({
    border: `2px dashed ${theme.palette.adminPanel.borderColor}`,
    padding: 3,
    textAlign: "center",
    borderRadius: 2,
    cursor: "pointer",
    color: theme.palette.adminPanel.textColor,
    backgroundColor: isDragActive
      ? theme.palette.adminPanel.calendarBgHover
      : "transparent",
  });

export const dropzoneEmptyStyles: SxProps<Theme> = (theme) => ({
  color: theme.palette.modalColors.colorLable,
});

export const fileNameStyles: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "row",
  gap: "10px",
  alignItems: "center",
  color: theme.palette.adminPanel.textColor,
  "& svg": {
    color: "inherit",
    fill: "currentColor",
  },
});

export const removeFileButtonStyles: SxProps<Theme> = (theme) => ({
  background: theme.palette.adminPanel.mainBg,
  transition: "opacity ease 0.3s",
  "&:hover": {
    opacity: 0.7,
  },
});

export const fieldsGridStyles: SxProps = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
  gap: 2,
};

export const presetMenuPaperStyles: SxProps<Theme> = (theme) => ({
  backgroundColor: theme.palette.adminPanel.calendarBg,
});

export const jsonTextFieldStyles: SxProps<Theme> = (theme) => ({
  "& .MuiInputBase-input": {
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
    fontSize: "0.8125rem",
    color: theme.palette.adminPanel.textColor,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.adminPanel.borderColor,
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#06B6D4",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#06B6D4",
  },
});
